import { TAGS, api } from "@/store/api"
import { balanceEndpoints } from "../balanceAPI"
import type {
  IGetMyReferralsQuery,
  IInfluencer,
  IMyReferralsResponse
} from "./referral.types"

const basePath = "/referral"

export const referralApi = api.enhanceEndpoints({
  addTagTypes: [TAGS.REFERRAL]
})

export const referralEndpoints = referralApi.injectEndpoints({
  endpoints: (builder) => ({
    getMyInfluencer: builder.query<IInfluencer, void>({
      query: () => ({
        url: `${basePath}/influencer/my`,
        method: "GET"
      }),
      providesTags: () => [{ type: TAGS.REFERRAL, id: "MY_INFLUENCER" }]
    }),

    getMyReferrals: builder.query<IMyReferralsResponse, IGetMyReferralsQuery>({
      query: ({ page, limit }) => ({
        url: `${basePath}/my`,
        method: "GET",
        params: { page, limit }
      }),
      providesTags: (_, __, { page }) => [
        { type: TAGS.REFERRAL, id: `MY_LIST_${page}` }
      ]
    }),

    claimReferralRewards: builder.mutation<IInfluencer, void>({
      query: () => ({
        url: `${basePath}/influencer/my/claim`,
        method: "PATCH"
      }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled
          dispatch(
            referralEndpoints.util.invalidateTags([{ type: TAGS.REFERRAL }])
          )
          dispatch(
            balanceEndpoints.util.invalidateTags([{ type: TAGS.BALANCE }])
          )
        } catch {
          /* handled globally */
        }
      }
    })
  })
})

export const {
  useGetMyInfluencerQuery,
  useGetMyReferralsQuery,
  useClaimReferralRewardsMutation
} = referralEndpoints
